import { RcClasses } from '../../../foundation';
export var RcAvatarSizes = {
    xxsmall: 24,
    xsmall: 32,
    small: 40,
    medium: 64,
    large: 80,
    xlarge: 100,
};
export var RcAvatarClasses = RcClasses(['presenceWrapper', 'avatarContainer', 'mask'], 'RcAvatar');
export var RcAvatarFonts = {
    xlarge: 'display2',
    large: 'display1',
    medium: 'title2',
    small: 'subheading2',
    xsmall: 'subheading2',
    xxsmall: 'caption2',
};
